import api from "./api";

/**
 * Submit a request for one of the 3 requestable badge types.
 * @param {"qualification_verified"|"professional_certificate_verified"|"training_centre_registration_verified"} type
 * @param {object} evidence - the type-specific fields (e.g. degree/schoolName)
 * @param {File} document - the supporting document
 * @returns {Promise<{ message: string, badges: object[] }>}
 */
export const requestBadge = async (type, evidence, document) => {
  const formData = new FormData();
  formData.append("type", type);
  formData.append("evidence", JSON.stringify(evidence));
  if (document) formData.append("badgeDocument", document);

  const res = await api.post("/users/badges/request", formData);
  return res.data;
};
